import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export function ClientIssuesBanner({ items, onReview }) {
  if (!items?.length) return null;
  return (
    <div className="mb-6 flex items-center justify-between gap-4 rounded-xl border border-destructive/40 bg-destructive/5 px-5 py-3" data-testid="client-issues-banner">
      <div className="flex items-center gap-2 text-sm text-destructive font-medium">
        <AlertTriangle className="w-4 h-4" />
        {items.length} client{items.length === 1 ? "" : "s"} with upcoming bookings can't be reminded
      </div>
      <Button size="sm" variant="outline" onClick={onReview} data-testid="client-issues-review" className="rounded-sm">Review</Button>
    </div>
  );
}

export default function ClientIssuesDialog({ items = [], open, onOpenChange, onFix }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!shown && items.length) { onOpenChange(true); setShown(true); }
  }, [items.length, shown, onOpenChange]);

  return (
    <Dialog open={open && items.length > 0} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] overflow-y-auto" data-testid="client-issues-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-destructive" /> Needs your attention
          </DialogTitle>
          <DialogDescription>These clients have upcoming bookings but their reminder can't be delivered. Fix each one to clear the alert on Clients.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {items.map((c) => (
            <div key={c.id} className="flex items-start gap-4 rounded-xl border border-destructive/30 bg-destructive/5 p-4" data-testid={`client-issue-${c.id}`}>
              <div className="flex-1">
                <div className="font-medium text-sm">{c.name}</div>
                <p className="text-xs text-muted-foreground mt-1">{c.reason}</p>
              </div>
              <Button size="sm" onClick={() => { onOpenChange(false); onFix(c.id); }} data-testid={`client-issue-fix-${c.id}`}>Fix details</Button>
            </div>
          ))}
        </div>
        <button type="button" onClick={() => onOpenChange(false)} data-testid="client-issues-later"
          className="text-sm text-muted-foreground hover:text-foreground self-end">Remind me later</button>
      </DialogContent>
    </Dialog>
  );
}
